import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import ExecDashboardSource from 'sources/ExecDashboardSource';
import {Api} from 'sources/api';
import {List} from 'immutable';

function handleCancel(handler) {
  return error => {
    if (Api.isCancel(error)) {
      throw error;
    }
    handler(error);
  };
}

class ExecDashboardActions {
  constructor() {
    this.generateActions(
      'clearTrendData',
      ...generateAsyncActions(
        'getConversations',
        'getInterchanges',
        'getTalkListen',
        'getTrendData',
        'getTopicTrendPercentData',
        'getTopicTrendPercentDataForTeam',
        'getTeamsInAccount',
        'getDashboardTriggers',
        'getTopicMetrics'
      )
    );
  }

  getConversations({teams, startDate, endDate}) {
    return dispatch => {
      dispatch();
      return ExecDashboardSource.getConversations({
        teams,
        startDate,
        endDate,
      }).then(this.getConversationsSuccess, this.getConversationsError);
    };
  }

  getTrendData({teamId, direction, type, startDate, endDate, additionalTeamIds = List(), context}) {
    return dispatch => {
      dispatch();
      return ExecDashboardSource.getTrendData({
        teamId,
        direction,
        type,
        startDate,
        endDate,
        additionalTeamIds,
        context,
      }).then(
        trendData => this.getTrendDataSuccess(trendData),
        handleCancel(this.getTrendDataError)
      );
    };
  }

  getTopicTrendPercentData({
    teamId,
    direction,
    startDate,
    endDate,
    additionalTeamIds = List(),
    context,
  }) {
    return dispatch => {
      dispatch();
      return ExecDashboardSource.getTopicTrendPercentData({
        teamId,
        direction,
        startDate,
        endDate,
        additionalTeamIds,
        context,
      }).then(
        trendData => this.getTrendDataSuccess(trendData),
        handleCancel(this.getTrendDataError)
      );
    };
  }

  getInterchanges({teams, startDate, endDate}) {
    return dispatch => {
      dispatch();
      return ExecDashboardSource.getInterchanges({
        teams,
        startDate,
        endDate,
      }).then(this.getInterchangesSuccess, this.getInterchangesError);
    };
  }

  getTalkListen({teams, startDate, endDate}) {
    return dispatch => {
      dispatch();
      return ExecDashboardSource.getTalkListen({
        teams,
        startDate,
        endDate,
      }).then(this.getTalkListenSuccess, this.getTalkListenError);
    };
  }

  getDashboardTriggers(teamIds) {
    return dispatch => {
      dispatch();
      return ExecDashboardSource.getDashboardTriggers(teamIds).then(
        this.getDashboardTriggersSuccess,
        this.getDashboardTriggersError
      );
    };
  }

  getTopicMetrics({teams, startDate, endDate}) {
    return dispatch => {
      dispatch();
      return ExecDashboardSource.getTopicMetrics({
        teams,
        startDate,
        endDate,
      }).then(this.getTopicMetricsSuccess, this.getTopicMetricsError);
    };
  }

  getTeamsInAccount() {
    return dispatch => {
      dispatch();
      return ExecDashboardSource.getTeamsInAccount().then(
        this.getTeamsInAccountSuccess,
        this.getTeamsInAccountError
      );
    };
  }
}

export default alt.createActions(ExecDashboardActions);
